import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Shiitake from 'shiitake';

class LineClamp extends PureComponent {
    static propTypes = {
        children: PropTypes.string,
        lines: PropTypes.number.isRequired,
        overflowNode: PropTypes.node
    };

    static defaultProps = {
        overflowNode: ' [...]'
    };

    render() {
        const {children} = this.props;

        return <Shiitake {...this.props}>{children}</Shiitake>;
    }
}

export default LineClamp;
